const toErrorMessage = (e: unknown) => (e instanceof Error ? e.message : "Unknown error");

export default toErrorMessage;
